/* Filtri i gjenerates dhe i pjeses per rezultatet e Bacit.
   Problemi qe zgjidh: kerkimi i Shopify-t kthen edhe F20 (2011–2014) kur klienti tha
   F20 Facelift, dhe kthen front lip kur klienti kerkoi parakolp. Asnjera nuk i hyn.
   Testet, ne kete rend:
     1. kodi     — titulli duhet ta permbaje kodin e gjenerates (f20, w205, g20...)
     2. facelift — nese gjenerata ka dy versione, LCI/Facelift duhet te perputhet sakte
     3. vitet    — vitet ne titull duhet te mbivendosen me vitet e gjenerates (pa toleranca)
     4. pjesa    — nese jane dhene fjalet e pjeses, titulli duhet ta permbaje njeren
   Nese pas filtrit nuk mbetet asgje, kthen liste boshe — Baci e thote hapur, nuk zevendeson. */
(function () {
  function norm(s) {
    return (s || '').toLowerCase().replace(/ë/g, 'e').replace(/ç/g, 'c').replace(/\s+/g, ' ');
  }
  function years(title) {
    var m = norm(title).match(/(19|20)\d{2}/g);
    if (!m || !m.length) return null;
    var f = parseInt(m[0], 10);
    var t = m.length > 1 ? parseInt(m[1], 10) : 9999;
    if (t < f) t = 9999;
    return { f: f, t: t };
  }
  function isFacelift(s) {
    var n = ' ' + norm(s) + ' ';
    return n.indexOf('facelift') > -1 || n.indexOf(' lci ') > -1;
  }
  window.BaciFilter = function (products, chosen, code, twoVariants, partWords) {
    if (!products || !products.length) return [];
    var wantFL = chosen ? isFacelift(chosen.g) : false;
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var title = products[i].title || '';
      var n = norm(title);

      if (code && code.length >= 2 && n.indexOf(code) === -1) continue;
      if (twoVariants && isFacelift(title) !== wantFL) continue;

      if (chosen && chosen.f) {
        var y = years(title);
        if (y) {
          var cf = chosen.f, ct = chosen.t || 9999;
          if (y.t < cf || y.f > ct) continue;
        }
      }

      if (partWords && partWords.length) {
        var hit = false;
        for (var j = 0; j < partWords.length; j++) if (n.indexOf(partWords[j]) > -1) { hit = true; break; }
        if (!hit) continue;
      }

      out.push(products[i]);
    }
    return out;
  };
})();
